// @avantia common-code
import { Policy } from '../types/policyTypes';
import { createMockPolicy } from './shared';

export const label = 'Unoccupied - Extended Perils';

export const policy: Policy = createMockPolicy({
  policyNumber: 'B12/4639278',
  policyDetailsId: '123441237775',
  coverType: 'Buildings',
  isUnoccupied: true,
  hasUnoccupiedExtendedPerils: true
});
